import React from 'react'
import * as SG from '../../constants/AppSettings'
import * as RT from '../../constants/Routing'
import { Link } from 'react-router-dom'
import Modal from '../App/Modal'
import ReactDOM from 'react-dom'
import defaultPhoto from '../../lib/images/default-back.jpg'
export default class Component extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      title1: '',
      title2: '',
      title3: '',
      body1: '',
      body2: '',
      body3: '',
      openModal: false,
    }
  }

  componentWillUnmount = () => {
    this.closeModal()
  }

  componentWillMount = () => {
    if (this.props.circle) {
      this.parseDescription(this.props.circle.description)
    }
  }

  parseDescription = (desc) => {
    if (!!desc) {
      let title1, title1_reg, title2, title2_reg, title3, title3_reg, body1, body1_reg, body2, body2_reg, body3, body3_reg, reg

      reg = new RegExp(`${SG.COMMUNITY_TITLE1_MARK}..${SG.COMMUNITY_TITLE1_MARK}`)
      title1_reg = desc.match(reg)
      title1 = !!title1_reg ? title1_reg[0] : ''

      reg = new RegExp(`${SG.COMMUNITY_TITLE2_MARK_REG}..${SG.COMMUNITY_TITLE2_MARK_REG}`)
      title2_reg = desc.match(reg)
      title2 = !!title2_reg ? title2_reg[0] : ''

      reg = new RegExp(`${SG.COMMUNITY_TITLE3_MARK_REG}..${SG.COMMUNITY_TITLE3_MARK_REG}`)
      title3_reg = desc.match(reg)
      title3 = !!title3_reg ? title3_reg[0] : ''

      reg = new RegExp(`${SG.COMMUNITY_BODY1_MARK_REG}..${SG.COMMUNITY_BODY1_MARK_REG}`)
      body1_reg = desc.match(reg)
      body1 = !!body1_reg ? body1_reg[0] : ''

      reg = new RegExp(`${SG.COMMUNITY_BODY2_MARK_REG}..${SG.COMMUNITY_BODY2_MARK_REG}`)
      body2_reg = desc.match(reg)
      body2 = !!body2_reg ? body2_reg[0] : ''

      reg = new RegExp(`${SG.COMMUNITY_BODY3_MARK_REG}..${SG.COMMUNITY_BODY3_MARK_REG}`)
      body3_reg = desc.match(reg)
      body3 = !!body3_reg ? body3_reg[0] : ''

      this.setState({
        title1,
        title2,
        title3,
        body1,
        body2,
        body3
      })
    }
  }

  openModal = () => {
    this.setState({
      openModal: true
    })
  }

  closeModal = () => {
    this.setState({
      openModal: false
    })
  }

  destroyCommunity = (id) => {
    this.closeModal()
    this.props.communityDestroy(id)
  }

  removeCommunity = (id) => {
    const userId = this.props.currentUser.id
    this.closeModal()
    this.props.communityUserDefect(id, userId)
  }

  render = () => {
    // console.log(this.props)
    const circle = this.props.circle
    let photo = defaultPhoto, name, id, status, statusClass, currentUser, hostUser

    if (circle) {
      photo = circle.photo || defaultPhoto
      // const host = circle.host
      name = circle.name || '(サークル名未設定)'
      // const category = circle.category
      // const description = circle.description
      id = circle.id
      status = circle.published ? '公開' : '下書き保存'
      statusClass = circle.published ? 'published' : 'draft'

      currentUser = this.props.currentUser
      hostUser = circle.host
    }


    let modal = null
    if (currentUser) {
      if (currentUser.id === hostUser.id) {
        modal = (
          <Modal
            okClickHandler={() => this.destroyCommunity(id)}
            headerTitle='サークルを削除します。'
            isOpen={this.state.openModal}
            closeModal={this.closeModal}
            okText='削除する'
          >
            <p>一度削除したサークルは元に戻せません。</p>
            <p>本当に削除してよろしいですか？</p>
          </Modal>
        )
      } else {
        modal = (
          <Modal
            okClickHandler={() => this.removeCommunity(id)}
            headerTitle='サークルから退会します。'
            isOpen={this.state.openModal}
            closeModal={this.closeModal}
            okText='退会する'
          >
            <p>本当に退会してよろしいですか？</p>
          </Modal>
        )
      }

    }

    return (
      <div className={'circle-list-item clearfix ' + statusClass}>
        
        {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}

        <div style={{ backgroundImage: `url(${photo})` }} className='circle-list-thumbnail'></div>
        <div className='circle-list-body'>
          <h3 className='circle-list-name'>{name}</h3>
          <div className='circle-list-action-wrap clearfix'>
            <span className='circle-status-text'>{status}</span>
            {(() => {
              if (hostUser && currentUser) {
                if (hostUser.id === currentUser.id) {
                  return (
                    <Link to={RT.COMMUNITY_EDIT_PATH.replace(/:id/, id)} className='btn btn-warning'>編集</Link>
                  )
                }
              }
            })()}
            <Link to={RT.COMMUNITY_PATH.replace(/:id/, id)} className='btn btn-white'>詳細</Link>
            {(() => {
              if (hostUser && currentUser) {
                if (hostUser.id === currentUser.id) {
                  return (
                    <Link to={RT.COMMUNITY_MANAGE_PATH.replace(/:id/, circle.id)} className='btn btn-danger' >管理</Link>
                  )
                } else {
                  return (
                    <span className='btn btn-danger' onClick={this.openModal}>退会</span>
                  )
                }
              }
            })()}
            
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Community/ListItem.jsx